import React, { useState } from 'react';
import classNames from 'classnames';
import './GridStyles.scss';
import { useIntl } from 'react-intl';
import { Icons } from '../BootstrapComponents/BootstrapComponents';

export default function GridHeader(props) {
  const {
    columns,
    sort = '',
    changeSort = () => {},
    hideHeader = false,
  } = props;
  const { formatMessage } = useIntl();
  if (hideHeader) {
    return null;
  }

  const renderHeaderCell = (item, key) => {
    const { headerStyle = {}, headerClassName, headerCallback = () => {} } = item;
    let content = '';
    if (item.headerFormatter && typeof item.headerFormatter === 'function') {
      content = item.headerFormatter(content, item);
    } else {
      content = formatMessage({ id: item.text || item.dataField, defaultMessage: item.text || ' ' });
    }
    const sortName = item?.sortField || item.dataField;
    const isSorted = sort === `-${sortName}` || sort === sortName;
    const isDesk = sort === `-${sortName}`;

    return (
      <th
        key={key}
        style={headerStyle}
        className={classNames('table-header-cell', `column-${key}`, headerClassName, { 'sorted-column': !item.disableSort }, { 'active-sort': isSorted })}
        role="columnheader"
        scope="col"
        onClick={() => (item.dataField === 'setting' || item.dataField === 'checkBox' ? headerCallback() : !item.disableSort && changeSort(sortName))}
      >
        <div className="table-column-wrapper">
          <span className={classNames('table-column')}>
            {content}
          </span>
          {item.dataField !== 'setting' && item.dataField !== 'checkBox' && !item.disableSort
            ? (
              <span className="table-column-sorted">
                {isSorted ? (
                  isDesk ? <Icons customIcon width={24} height={24} icon="sort-desk" /> : <Icons customIcon width={24} height={24} icon="sort-ask" />
                ) : (
                  <Icons customIcon width={24} height={24} icon="sort-all" />
                )}
              </span>
            ) : null}
        </div>
      </th>
    );
  };

  return (
    <thead className="data-table-header">
      <tr className="table-header-row">
        {columns.map(renderHeaderCell)}
      </tr>
    </thead>
  );
}
